interface OrderBookItem {
  price: number;
  amount: number;
  total: number;
}

interface OrderBookProps {
  currentPrice: number;
  priceChange: number;
}

export default function OrderBook({ currentPrice, priceChange }: OrderBookProps) {
  const buyOrders: OrderBookItem[] = [
    { price: 0.0244, amount: 12500, total: 305 },
    { price: 0.0243, amount: 8900, total: 216.27 },
    { price: 0.0242, amount: 15600, total: 377.52 },
    { price: 0.0241, amount: 21000, total: 506.1 },
    { price: 0.0240, amount: 18500, total: 444 },
  ];

  const sellOrders: OrderBookItem[] = [
    { price: 0.0245, amount: 11200, total: 274.4 },
    { price: 0.0246, amount: 9800, total: 241.08 },
    { price: 0.0247, amount: 14300, total: 353.21 },
    { price: 0.0248, amount: 19500, total: 483.6 },
    { price: 0.0249, amount: 16700, total: 415.83 },
  ];

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg sm:rounded-xl border border-gray-700 p-3 sm:p-4">
      <h2 className="text-sm sm:text-base font-bold text-white mb-3 sm:mb-4">Order Book</h2>
      
      <div className="mb-3 sm:mb-4">
        <div className="grid grid-cols-3 gap-2 text-[10px] sm:text-xs text-gray-400 mb-2">
          <div>Price (USDT)</div>
          <div className="text-right">Amount (PEP)</div>
          <div className="text-right">Total</div>
        </div>
        {sellOrders.map((order, index) => (
          <div
            key={index}
            className="grid grid-cols-3 gap-2 text-[10px] sm:text-xs py-1 hover:bg-red-500/10 transition-colors cursor-pointer rounded"
          >
            <div className="text-red-400 font-medium">${order.price.toFixed(4)}</div>
            <div className="text-right text-gray-300">{order.amount.toLocaleString()}</div>
            <div className="text-right text-gray-400">${order.total.toFixed(2)}</div>
          </div>
        ))}
      </div>

      <div className="bg-gray-900/50 rounded-lg p-2 sm:p-3 mb-3 sm:mb-4 text-center">
        <div className="text-lg sm:text-xl font-bold text-white">${currentPrice.toFixed(4)}</div>
        <div className={`text-[10px] sm:text-xs ${priceChange >= 0 ? 'text-green-400' : 'text-red-400'}`}>
          {priceChange >= 0 ? '↑' : '↓'} {Math.abs(priceChange).toFixed(2)}%
        </div>
      </div>

      <div>
        <div className="grid grid-cols-3 gap-2 text-[10px] sm:text-xs text-gray-400 mb-2">
          <div>Price (USDT)</div>
          <div className="text-right">Amount (PEP)</div>
          <div className="text-right">Total</div>
        </div>
        {buyOrders.map((order, index) => (
          <div
            key={index}
            className="grid grid-cols-3 gap-2 text-[10px] sm:text-xs py-1 hover:bg-green-500/10 transition-colors cursor-pointer rounded"
          >
            <div className="text-green-400 font-medium">${order.price.toFixed(4)}</div>
            <div className="text-right text-gray-300">{order.amount.toLocaleString()}</div>
            <div className="text-right text-gray-400">${order.total.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
